import type {SVGProps} from 'react';
import * as React from 'react';
export const ErrorCircleIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 32 33"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M9.168.973c-.07.025-.197.1-.281.165C8.77 1.23 2.57 7.621.443 9.842c-.24.252-.323.362-.376.503l-.067.18V23.32l.067.18c.053.14.136.25.376.502 2.105 2.198 8.327 8.613 8.444 8.704.3.234-.297.216 7.113.216s6.813.018 7.113-.216c.085-.066 1.76-1.783 3.725-3.816 5.387-5.575 5.017-5.185 5.083-5.364.032-.086.07-.17.084-.186.034-.04.036-12.891.002-12.87-.014.008-.051-.056-.082-.144-.065-.183.331.236-5.087-5.372-1.964-2.033-3.64-3.75-3.725-3.816-.3-.234.3-.216-7.127-.213-5.708.002-6.709.009-6.818.048ZM5.96 7.023l-3.944 4.081V22.74L5.96 26.82l3.944 4.082h12.192l3.944-4.082 3.944-4.081V11.105L26.04 7.023l-3.944-4.082H9.904L5.96 7.023ZM.016 16.922c0 3.546.003 4.997.008 3.224.005-1.773.005-4.675 0-6.448-.005-1.773-.008-.322-.008 3.224Zm8.32-.95c-.279.11-.485.3-.596.55a1.127 1.127 0 0 0 0 .803c.083.19.28.392.484.498l.144.075 7.584.009c6.84.008 7.597.003 7.718-.042.331-.125.593-.435.644-.764.076-.48-.144-.889-.586-1.096l-.16-.074-7.568.002c-5.721.001-7.591.011-7.664.04Z"
			clipRule="evenodd"
		/>
	</svg>
);
